import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { History } from 'history';
import { ConnectedRouter } from 'connected-react-router';

import comparisonPage from './pages/comparison';
import comparisonHighlightPage from './pages/comparisonhighlight';
import comparisonSearchPage from './pages/comparisonsearch';
import uploadPage from './pages/upload';
import uploadForHighlightPage from './pages/uploadForHighlight';
import uploadForSearchPage from './pages/uploadForSearch';
import searchPage from './pages/search';
import uploadForRiskJudgePage from './pages/uploadForRiskJudge';
import riskJudgePage from './pages/riskJudge';
import loginPage from './pages/login';

interface Props {
  history: History;
}

class App extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }
  render() {
    const { history } = this.props;
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/login" component={loginPage} />
          <Route exact path="/" component={uploadPage} />
          <Route path="/uphilight" component={uploadForHighlightPage} />
          <Route path="/upsearch" component={uploadForSearchPage} />
          <Route path="/comparison" component={comparisonPage} />
          <Route path="/comparisonhighlight" component={comparisonHighlightPage} />
          <Route path="/comparisonsearch" component={comparisonSearchPage} />
          <Route path="/search" component={searchPage} />
          <Route path="/riskjudge" component={uploadForRiskJudgePage} />
          <Route path="/judge" component={riskJudgePage} />
        </Switch>
      </ConnectedRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx